module.exports = __webpack_public_path__ + "img/2.b93158e8.svg";